import { Address } from './Address';
import { ClientLocation, Client } from './clientLocation';
import { SearchPackage } from './searchPackage';
import * as moment from 'moment'; 
import { LogEntry, LogParserType } from './LogEntry';
import { UserLight } from './userLight';
import { HardDeclineReason } from './hardDeclineReason';
import { PMScorePointLossReason } from './PMScorePointLossReason';
import { HammerGestureConfig } from '@angular/platform-browser';

export class PaymentResponse {
	payments: PaymentResponseItem[];
}
export class PaymentResponseItem {
	firstName: string;
	lastName: string;
	accountNumber: string;
	email: string;
	channelType: string;
	brandType: string;
	lastFour: string;
	id: number;
	amount: number;
	grossAmount: number;
	settledAmount: number;
	targetId: number;
}


export class ScreeningInvite {
    id: number;
    token: string;
    clientId: number;
    userId: number;
    clientLocationId:number;
    invitedParty: string;
    messageType: number;
    invitationDate: Date;
    searchPackageId : number;
    applicantPay : boolean;
    firstName : string;
    lastName : string;
    inviteSent:boolean;
    applicantReview : boolean;
	rentalAmount : number;
	client : Client;
	clientLocation : ClientLocation;
	searchPackage : SearchPackage;
	paymentData: PaymentResponse;
	htmlbody: string;
	sendingUser : UserLight;
	formattedDate : string;
	formattedTime : string;
	clientName : string;
	requestingUserId : number;
	jwt : string;
	released : boolean;
	screeningId : number;
}

export class Screening {
	id: number;
	screeningDate: Date;
	applicantId: number;
	firstName: string;
	lastName: string;
	middleName: string;
	sSN: string;
	dOB: Date;
	street: string;
	city: string;
	state: string;
	zipCode: string;
	monthlyIncome: number;
	screeningToken: any;
	invitation: ScreeningInvite;
	applicant: Applicant;
}

export class ScreeningLight {
	id: number;
	invitationId: number;
	clientId: number;
	clientName : string;
	locationName : string;
	locationStreet: string;
	locationId : number;
	userName : string;
	userEmail : string;
	userPhone : string;
	applicantFirstName : string;
	applicantLastName : string;
	applicantSSN : string;
	applicantDOB : Date;
	applicantEmail : string;
	applicantStreet : string;
	applicantCity : string;
	applicantState : string;
	applicantZipCode : string;
	applicantPhone : string;
	dateLastModified : Date;
	initiatingUser: number;
	invitationDate: Date;
	displayDate : string;
	searchPackageId: number;
	screeningId: number;
	screeningDate: Date;
	fullName: string;
	screeningToken: string;
	residentIQ: number;
	productName : string;
	fax : string;
	recommendedDecision : string;
	propertyDecision : string;
	reportStatus : string;
	editing : boolean;
	saved : boolean = false;
	warned : boolean = false;
	additionalData : ScreeningAdditionalData[];
	applicantAliases : string[];
	canceled : boolean;
	canceledDate : Date;
	cancelUser: number;
	monthlyIncome: number;
	rent : number;
	showFullReport : boolean;
	creditOnlyReport : boolean;
	limitedCredentials : boolean;
	coApp : boolean;
	groupId : string;
	conditionalVerbiage : ConditionalAcceptanceVerbiage[];
	hardDeclineReasons : HardDeclineReason[];
	ffdSocial: boolean;
	screeningClosed: boolean;
	//RIQ-2427:
	prequalOverride: boolean = false;
	applicantSuppliedIncome : number;
	appliedScoringModel: string;
	
	public get reportableHardDeclineReasons() : HardDeclineReason[] {
		
		if(this.hardDeclineReasons){
			if(this.hardDeclineReasons.length > 0){
				let listo = this.hardDeclineReasons.filter(hd => {return !hd.isCrimGridHardDecline}).map(hdr => { return Object.assign(new HardDeclineReason(),hdr)});
				if(this.isInPrequalState) return listo.filter(hd=>{ return hd.declineReasonId == 3 || hd.declineReasonId == 4 || hd.declineReasonId == 5 || hd.declineReasonId == 2;});
				else return listo;
			}else
				return new Array<HardDeclineReason>(); 
		}
		else 
			return new Array<HardDeclineReason>(); 
	}
	

	pmScorePointLossReasons : PMScorePointLossReason[];
	public get recDecDisplay() : string {
		if(this.conditionalVerbiage.length > 0 && this.recommendedDecision.toLowerCase().includes('conditional')) return `Conditional-${this.conditionalVerbiage[0].verbiage}`
		// if(!this.recommendedDecision.includes('conditional')) return this.recommendedDecision;
		return this.recommendedDecision;
	}

	isInPrequalState : boolean;
	// public get isInPrequalState() : boolean {
	// 	if(this.prequalOverride) return true;
	// 	if(!this.creditOnlyReport) return false;
	// 	else{
	// 		if(!this.additionalData) return false;
	// 		if(this.recommendedDecision && this.recommendedDecision == 'Decline') return false;
	// 		return this.additionalData.filter(addy => { return addy.searchStatus == 8}).length != this.additionalData.length;
	// 	}
	// }
	
	public get isConditional() : boolean {
		if(this.propertyDecision) return this.propertyDecision.toLowerCase().includes('conditional');
		if(this.recommendedDecision) return this.recommendedDecision.toLowerCase().includes('conditional');
	}
	
}

export class ScreeningAdditionalData {
	screeningId : number;
	packageName : string;
	packageCost : number;
	searchType : string;
	searchName : string;
	searchQualifier : string;
	searchStatus : number;
	searchEntryId : number;
	rerunSearch : boolean = false;
	computedScore : number;
	passed : boolean;
	responseRecieved : boolean;
	vendorRecordCount : number;
}

export class Applicant {
	id: number;
	firstName: string;
	lastName: string;
	middleName: string;
	sSN: string;
	dOB: Date;
	addressId: number;
	clientId: number;
	address: Address;
}

export class ObjectUpdatePayload {
	objectName: string;
	propertyName: string;
	oldValue: string;
	newValue: string;
	objectId : number;
	userId: number;
	saved : boolean;
	clientId : number;
	logOnly : boolean;
	delete : boolean;
}

export class ConditionalAcceptanceVerbiage {
	id : number;
	screeningId : number;
	verbiage : string;
	timestamp : Date;
	conditionalLevel : string;
	verbType : number
}
